import axios from "axios";
import { getAuth } from "firebase/auth";
import { getSessionToken } from "@shopify/app-bridge/utilities";

axios.interceptors.request.use(
  async config => {
    const newConfig = config;

    if (window.appBridgeApp) {
      // Send token to your backend via HTTPS
      // ...
      const sessionToken = await getSessionToken(window.appBridgeApp);
      newConfig.headers.post.Authorization = sessionToken;
      newConfig.headers.get.Authorization = sessionToken;
      newConfig.headers.put.Authorization = sessionToken;
      newConfig.headers.delete.Authorization = sessionToken;
      const auth = getAuth();
      if (auth.currentUser) {
        auth.currentUser.getIdToken().then(idToken => {
          // Send token to your backend via HTTPS
          // ...
          newConfig.headers.post.fbToken = `${idToken}`;
          newConfig.headers.get.fbToken = `${idToken}`;
          newConfig.headers.put.fbToken = `${idToken}`;
          newConfig.headers.delete.fbToken = `${idToken}`;
          return Promise.resolve(newConfig);
        });
      }
      return Promise.resolve(newConfig);
    }

    return newConfig;
  },
  error =>
    // Do something with request error
    Promise.reject(error)
);

export default {
  post(url, request) {
    return axios
      .post(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  get(url) {
    return axios
      .get(`${window.serverURL}${url}`)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  put(url, request) {
    return axios
      .put(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  delete(url, request) {
    return axios
      .delete(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  postSkipAuth(url, request) {
    return axios
      .post(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  }
};
